import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  IconModule,
  IconButtonModule,
  TooltipModule,
  ButtonModule
} from '@liberty-financial/ng-components';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { PipesModule } from '@shared/pipes/pipes.module';
import { InlineSpinnerModule } from '@shared/components/inline-spinner/inline-spinner.module';

import { ContextMenuComponent } from './context-menu/context-menu.component';
import { SidebarNavComponent } from './sidebar-nav/sidebar-nav.component';
import { SparkSharedSidebarSubMenuComponent } from './sidebar-sub-menu/sub-menu.component';
import { LoadModule } from '../load/load.module';
import { DisplayWarningPipe } from './pipes/menu.display.pipe';
import { SparkCoreModule } from '@core/core.module';

@NgModule({
  declarations: [
    SidebarNavComponent,
    ContextMenuComponent,
    SparkSharedSidebarSubMenuComponent,
    DisplayWarningPipe
  ],
  imports: [
    BsDropdownModule.forRoot(),
    CommonModule,
    RouterModule,
    FormsModule,
    IconModule,
    IconButtonModule,
    TooltipModule,
    ButtonModule,
    InlineSpinnerModule,
    LoadModule,
    PipesModule,
    SparkCoreModule
  ],
  exports: [
    SidebarNavComponent,
    ContextMenuComponent,
    SparkSharedSidebarSubMenuComponent
  ]
})
export class MenuModule {}
